export const Selectors = {
  gallery: ' .gallery',
  gallerySlider: '.gallery-slider',
  mediaSlider: '.media-slider'
};
